/** Warehouse label kinds — shared by print schemas, backend print types, and frontend constants. */

export const LABEL_TYPES = ['stock', 'pick bin'] as const;
export type LabelType = (typeof LABEL_TYPES)[number];
